import { render } from "./WorkCard.vue?vue&type=template&id=4ceca0fe"
import script from "./WorkCard.vue?vue&type=script&lang=js"
export * from "./WorkCard.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/new-portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__